import { Box, Button, Card, Column, Icon, toast, useBreakpoint } from '@palmetto/palmetto-components';
import { useNavigate, useParams } from 'react-router-dom';

import { PriceSheetStatus, ProgramType, UserPermissions } from 'types';

import { useArchivePriceSheetMappingMutation } from '../../../services/pricing';
import RequirePalmettoFinanceUser from '../../auth/RequirePalmettoFinanceUser';
import RequirePermissions from '../../auth/requirePermissions';

import { FilteredMappingsList } from './FilteredMappingsList';
import './mappings.css';
import { mappingsColumnConfig } from './MappingTables';

export const Mappings = () => {
  const { isPhone } = useBreakpoint();
  const navigate = useNavigate();
  const { programType = ProgramType.solar } = useParams<{ programType: ProgramType }>();
  const [archivePriceSheetMappingMutation] = useArchivePriceSheetMappingMutation();
  const handleArchive = async (id: string) => {
    try {
      const confirmed = window.confirm('Are you sure you want to Archive this mapping?');

      if (!confirmed) return;
      await archivePriceSheetMappingMutation({ id }).unwrap();
      toast.success('Price Sheet Mapping Archived successfully');
    } catch (e) {
      console.error(e);
      toast.error('Error archiving Price Sheet Mapping');
    }
  };
  return (
    <Card padding="sm">
      <Card.Header>
        <Box direction="row" justifyContent="space-between">
          <Box fontSize="md" fontWeight="medium">
            Org-Price Mappings
          </Box>
          <Box direction="row" gap="sm">
            <RequirePalmettoFinanceUser>
              <RequirePermissions permissions={[UserPermissions.pricingAdmin]}>
                {(programType === ProgramType.solar ||
                  programType === ProgramType.newHomes ||
                  programType === ProgramType.energyBackup ||
                  programType === ProgramType.consumerSolar) && (
                  <>
                    <Button
                      as="button"
                      variant="secondary"
                      tone="neutral"
                      size={{ base: 'sm', desktop: 'md' }}
                      aria-label="view bulk jobs"
                      onClick={() => navigate(`/admin/pricing/${programType}/mappings/bulk-jobs`)}
                    >
                      Bulk Jobs
                    </Button>
                    <Button
                      as="button"
                      variant="secondary"
                      tone="neutral"
                      size={{ base: 'sm', desktop: 'md' }}
                      aria-label="bulk edit mapping"
                      onClick={() =>
                        navigate(
                          `/admin/pricing/${programType}/mappings/bulk-edit?advancedFilters=${encodeURIComponent('[{"id": "status", "operation": "Equal", "selectedValues": ["active"]}]')}`,
                        )
                      }
                    >
                      Bulk Edit
                    </Button>
                  </>
                )}
                <Button
                  as="button"
                  variant="primary"
                  iconPrefix="add"
                  size={{ base: 'sm', desktop: 'md' }}
                  aria-label="create mapping"
                  onClick={() => navigate(`/admin/pricing/${programType}/mappings/create`)}
                >
                  {!isPhone && 'Mapping'}
                </Button>
              </RequirePermissions>
            </RequirePalmettoFinanceUser>
          </Box>
        </Box>
      </Card.Header>
      <FilteredMappingsList
        columnConfig={
          [
            ...mappingsColumnConfig.baseStart,
            ...mappingsColumnConfig[programType],
            ...mappingsColumnConfig.baseEnd,
            {
              sticky: 'right',
              render: (_cell: any, row: any) => (
                <Box direction="row" gap="lg" alignItems="center">
                  <Box>
                    {row.status !== 'archived' && (
                      <Button
                        size="sm"
                        variant="tertiary"
                        tone="neutral"
                        onClick={() => {
                          window.open(
                            `/admin/pricing/${row.programType}/mappings/edit/${row.id}`,
                            '_blank',
                            'noopener,noreferrer',
                          );
                        }}
                      >
                        <Icon color="body-primary" name="settings" size="sm" />
                      </Button>
                    )}
                  </Box>
                  <Box>
                    {row?.status === PriceSheetStatus.active ? (
                      <Button
                        size="sm"
                        variant="secondary"
                        tone="neutral"
                        onClick={() => {
                          handleArchive(row.id);
                        }}
                      >
                        Archive
                      </Button>
                    ) : (
                      <></>
                    )}
                  </Box>
                </Box>
              ),
            },
          ] as Column[]
        }
      />
    </Card>
  );
};
